<template>
  <div class="list-item flex flex-column justify-between entity-primary">

    <div class="flex flex-row items-top justify-between f7 entity-secondary ttu lh-title tracked">
      <div class="flex flex-row items-center justify-start">
        <span class="db f6">{{ bid_directions[proc.direction].name }}</span>
        <span class="db pl1" :class="[proc.direction === 2 ? 'blue' : 'green']">
          {{ proc.direction === 2 ? '&#x2191;' : '&#x2193;' }}
        </span>
      </div>
      <div class="pl2"> № {{ proc.id }}</div>
    </div>

    <div class="pt1 flex flex-row items-center justify-start f6 ttl fw6">
      {{ statuses[proc.status].name }}
    </div>

    <router-link :to="{ name: 'procedure_card', params: { id: proc.id } }" class="pt3 link lh-copy f6 entity-primary">
      <div>
        <span class="text-line-3 f5 underline">
          {{ proc.title }}
        </span>
      </div>
      <div class="pt3">
        <font-awesome-icon :icon="['fa', 'user']" class="mr2 entity-icon"/>
        {{ manager }}
      </div>
    </router-link>

    <div class="pt3 entity-secondary">
      <div class="flex flex-row justify-between f7 ttl lh-copy tracked">
        <div class="flex">
          <div v-if="proc.participants_count" title="Кол-во участников" class="pr2">
            <span class="pr2"><font-awesome-icon icon="users" /></span><span>{{ proc.participants_count }}</span>
          </div>
          <div v-if="proc.product_count" title="Кол-во товаров" class="pr2">
            <span class="pr2"><font-awesome-icon icon="box-open" /></span><span>{{ proc.product_count }}</span>
          </div>
        </div>

        <div class="flex">
          <div title="Кол-во просмотров">
            <span class="pr1"><font-awesome-icon icon="eye" /></span><span>{{ proc.viewed_count ? proc.viewed_count : 0 }}</span>
          </div>
          <div v-if="duration(proc)" title="Длительность" class="pl2">
            <span class="pr1"><font-awesome-icon icon="clock" /></span><span>{{ duration(proc) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="minBidCountNotReached(proc) || expiredAgreement(proc) || expiredRating(proc)">
      <div class="pt1">
        <hr class="hr-circle">
      </div>
      <table class="entity-secondary f7">
        <tr v-if="minBidCountNotReached(proc)">
          <td class="entity-secondary"><font-awesome-icon icon="exclamation-circle" /></td>
          <td class="pl1">меньше {{ proc.min_bid_count }} участников</td>
        </tr>
        <tr v-if="expiredAgreement(proc)">
          <td class="red"><font-awesome-icon icon="exclamation-circle" /></td>
          <td class="pl1">Cогласование длится более 14 дней</td>
        </tr>
        <tr v-if="expiredRating(proc)">
          <td class="gold" style="vertical-align: top;"><font-awesome-icon icon="exclamation-circle" /></td>
          <td class="pl1">Не выставлен рейтинг более 14 дней с даты поставки</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { humanizeDuration, daysDuration } from '@/plugins/consts.js'
import { momentFromString } from '@/utils/datetime.js'

const moment = require('moment')
moment.locale('ru')

export default {
  props: ['proc'],
  computed: {
    ...mapGetters('procedure', [
      'organizations', 'managers', 'bid_directions', 'periods', 'statuses', 'procedures', 'filteredProcedures'
    ]),
    manager () {
      return this.managersMap()[this.proc.manager]?.name || ''
    }
  },
  methods: {
    ...mapActions('procedure/filter', [
      'setStatus'
    ]),
    filterStatus (statusId) {
      this.setStatus([statusId])
    },
    format (dt) {
      return momentFromString(dt)?.format('DD.MM.YYYY')
    },
    duration (proc) {
      if (proc.date_closed) {
        return humanizeDuration(moment(proc.date_open), moment(proc.date_closed))
      } else if (proc.date_open) {
        return humanizeDuration(moment(proc.date_open), moment())
      } else {
        return null
      }
    },
    expiredAgreement (proc) {
      if (proc.status === 2) {
        return daysDuration(moment(proc.date_agreement), moment()) > 14
      } else {
        return null
      }
    },
    expiredRating (proc) {
      if (proc.status === 3 && proc.date_delivery && proc.rating === null) {
        return daysDuration(moment(proc.date_delivery), moment()) > 14
      } else {
        return false
      }
    },
    minBidCountNotReached (proc) {
      return proc.status === 1 && proc.bin_count < proc.min_bid_count
    },
    managersMap () {
      return Object.fromEntries(this.managers?.map(man => ([man.id, man]) || []))
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
